import { Box, Button, Grid, Modal } from "@mui/material";
import { SHOWN_USER_ROLE } from "consts/UserManagement";
import { capitalize } from "lodash";

const DetailAccountModal = ({ modalProps = {}, data = {}, onClose }) => {
  return (
    <Modal {...modalProps}>
      <Box
        sx={{
          position: "absolute",
          top: "55%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 800,
          overflow: "scroll",
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          px: "20px",
          py: "25px",
        }}
      >
        <div className='detail-modal-content'>
          <div className='font-semibold mb-12'>Account Details</div>
          <div className='grid gap-4'>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <div>
                  <p className='text-xs text-[#5F737F]'>Name</p>
                  <p className='text-sm'>{data?.name}</p>
                </div>
              </Grid>
              <Grid item xs={6}>
                <div>
                  <p className='text-xs text-[#5F737F]'>E-mail address</p>
                  <p className='text-sm'>{data?.email}</p>
                </div>
              </Grid>
              <Grid item xs={6}>
                <div>
                  <p className='text-xs text-[#5F737F]'>Phone Number</p>
                  <p className='text-sm'>{data?.phone_number ?? "-"}</p>
                </div>
              </Grid>
              <Grid item xs={6}>
                <div>
                  <p className='text-xs text-[#5F737F]'>Role</p>
                  <p className='text-sm'>
                    {SHOWN_USER_ROLE?.[data?.role] || capitalize(data?.role)}
                  </p>
                </div>
              </Grid>
              <Grid item xs={6}>
                <div>
                  <p className='text-xs text-[#5F737F] mb-1'>Status</p>
                  <div
                    className={`rounded-full px-2 py-1 ${
                      data?.status === "ACTIVE"
                        ? "bg-[#CAFAD2] text-[#039E5A] max-w-[57px]"
                        : "bg-[#FDDCD3] text-[#E52A49] max-w-[62px]"
                    }`}
                  >
                    <p className='text-sm'>{capitalize(data?.status)}</p>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>

          <div className='flex gap-4 justify-end mt-10'>
            <Button
              className='w-[200px] py-2 px-[17p]'
              onClick={onClose}
              variant='outlined'
            >
              <p className='text-black'>Close</p>
            </Button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default DetailAccountModal;
